import { PooledBenchmarkUnivService } from "../service/asyncBatchPooledBenchmarkUnivService";
import * as validations from "../utils/validations";

export class PooledBenchmarkUnivFunctions {
  fnBurgissCalcPooledBenchmarkIRRByWeight(
    universe: string = null,
    weight: string = null,
    startDate?: any,
    endDate?: any,
    weightingMethod: any = null,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const paramUniverse = validations.ValidateByUniverse(universe);

    const paramWeight = validations.ValidateByWeight(weight, "Weight");

    if (String(paramWeight).includes("Error")) {
      return "#INVALIDPARAMETERS - Weight is Mandatory";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }
    let validStartDate: any = new Date(0);
    if (startDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validStartDate = lstMeasurmentDate.startDates;
    } else {
      startDate = validations.isValidDate(startDate);
      if (startDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dSDate: boolean = validations.searchedDateInMeasurementDate(startDate, "S");
      if (dSDate == true) validStartDate = startDate;
    }

    if (validStartDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid start Date parameter";
    }
    const weightMethod = validations.getWeightMethod(weightingMethod);
    if (weightMethod.includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightMethod.Replace("Error ", "");
    }

    const reportvaluation = validations.validateReportedValuation(requireReportedValuation);
    if (reportvaluation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }

    const dateCmp: boolean = validations.dateCompare(validStartDate, validEndtDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    return new PooledBenchmarkUnivService().burgissCalcPooledBenchmarkIRRByWeight(
      paramUniverse,
      paramWeight,
      baseorlocalcurrency,
      alternateCurrrency,
      validStartDate,
      validEndtDate,
      weightMethod,
      reportvaluation,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledBenchmarkTWRRByWeight(
    universe: string = null,
    weight: string = null,
    startDate?: any,
    endDate?: any,
    weightingMethod: any = null,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string,
    advancedParameter?: string
  ) {
    const paramUniverse = validations.ValidateByUniverse(universe);

    const paramWeight = validations.ValidateByWeight(weight, "Weight");

    if (String(paramWeight).includes("Error")) {
      return "#INVALIDPARAMETERS - Weight is Mandatory";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }
    let validStartDate: any = new Date(0);
    if (startDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validStartDate = lstMeasurmentDate.startDates;
    } else {
      startDate = validations.isValidDate(startDate);
      if (startDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dSDate: boolean = validations.searchedDateInMeasurementDate(startDate, "S");
      if (dSDate == true) validStartDate = startDate;
    }

    if (validStartDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid start Date parameter";
    }
    const weightMethod = validations.getWeightMethod(weightingMethod);
    if (weightMethod.includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightMethod.Replace("Error ", "");
    }

    const reportvaluation = validations.validateReportedValuation(requireReportedValuation);
    if (reportvaluation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }

    const dateCmp: boolean = validations.dateCompare(validStartDate, validEndtDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new PooledBenchmarkUnivService().burgissCalcPooledBenchmarkTWRRByWeight(
      paramUniverse,
      paramWeight,
      baseorlocalcurrency,
      alternateCurrrency,
      validStartDate,
      validEndtDate,
      weightMethod,
      reportvaluation,
      uniqueCellId,
      advancedParameter
    );
  }
  fnBurgissCalcPooledBenchmarkIRRByCommitment(
    universe: string = null,
    weight: string = null,
    startDate?: any,
    endDate?: any,
    weightingMethod: any = null,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string
  ) {
    const paramUniverse = validations.ValidateByUniverse(universe);

    const paramWeight = validations.ValidateByWeight(weight, "Weight");

    if (String(paramWeight).includes("Error")) {
      return "#INVALIDPARAMETERS - Weight is Mandatory";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }
    let validStartDate: any = new Date(0);
    if (startDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validStartDate = lstMeasurmentDate.startDates;
    } else {
      startDate = validations.isValidDate(startDate);
      if (startDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dSDate: boolean = validations.searchedDateInMeasurementDate(startDate, "S");
      if (dSDate == true) validStartDate = startDate;
    }

    if (validStartDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid start Date parameter";
    }

    const weightMethod = validations.getWeightMethod(weightingMethod);
    if (weightMethod.includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightMethod.Replace("Error ", "");
    }

    const reportvaluation = validations.validateReportedValuation(requireReportedValuation);
    if (reportvaluation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    const dateCmp: boolean = validations.dateCompare(validStartDate, validEndtDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }

    return new PooledBenchmarkUnivService().BurgissCalcPooledBenchmarkIRRByCommitment(
      paramUniverse,
      paramWeight,
      baseorlocalcurrency,
      alternateCurrrency,
      validStartDate,
      validEndtDate,
      weightMethod,
      reportvaluation,
      uniqueCellId
    );
  }
  fnBurgissCalcPooledBenchmarkTWRRByCommitment(
    universe: string = null,
    weight: string = null,
    startDate?: any,
    endDate?: any,
    weightingMethod: any = null,
    currency?: string,
    requireReportedValuation?: any,
    uniqueCellId?: string,
    advancedParameter?: string
  ) {
    const paramUniverse = validations.ValidateByUniverse(universe);

    const paramWeight = validations.ValidateByWeight(weight, "Weight");

    if (String(paramWeight).includes("Error")) {
      return "#INVALIDPARAMETERS - Weight is Mandatory";
    }
    const baseorlocalcurrency = validations.validateBaseLocalCurrencyParam(currency);
    if (baseorlocalcurrency == "InValid") {
      return "#INVALIDPARAMETERS - Invalid Currency parameter";
    }
    const alternateCurrrency = validations.validateAlternateBaseCurrencyCode(currency);
    if (alternateCurrrency != null && alternateCurrrency != "" && alternateCurrrency.includes("InvError")) {
      return alternateCurrrency.Replace("InvError ", "");
    }
    let validEndtDate: any = new Date(0);

    if (endDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validEndtDate = lstMeasurmentDate.endDates;
    } else {
      endDate = validations.isValidDate(endDate);
      if (endDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dEDate: boolean = validations.searchedDateInMeasurementDate(endDate, "E");
      if (dEDate == true) validEndtDate = endDate;
    }

    if (validEndtDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid end Date parameter";
    }
    let validStartDate: any = new Date(0);
    if (startDate == null) {
      const lstMeasurmentDate = validations.measurmentDateSearch();
      validStartDate = lstMeasurmentDate.startDates;
    } else {
      startDate = validations.isValidDate(startDate);
      if (startDate === false) {
        return "#INVALIDPARAMETERS - Invalid End Date parameter";
      }
      const dSDate: boolean = validations.searchedDateInMeasurementDate(startDate, "S");
      if (dSDate == true) validStartDate = startDate;
    }

    if (validStartDate.year == 1) {
      return "#INVALIDPARAMETERS - Invalid start Date parameter";
    }
    const weightMethod = validations.getWeightMethod(weightingMethod);
    if (weightMethod.includes("Error")) {
      return "#INVALIDPARAMETERS - " + weightMethod.Replace("Error ", "");
    }

    const reportvaluation = validations.validateReportedValuation(requireReportedValuation);
    if (reportvaluation == 10) {
      return "#INVALIDPARAMETERS - Invalid RequireReportValuation parameter";
    }
    const dateCmp: boolean = validations.dateCompare(validStartDate, validEndtDate);
    if (dateCmp == false) {
      return "#INVALIDPARAMETERS - Begin Date must be prior to End Date";
    }
    advancedParameter = validations.validDynamicParameter(advancedParameter);
    if (String(advancedParameter).includes("Error")) {
      let str = String(advancedParameter);
      str = str.substring(6, str.length - 6);
      return "#INVALIDPARAMETERS - Duplicate " + str + " is not allowed in Advanced Params";
    }

    return new PooledBenchmarkUnivService().burgissCalcPooledBenchmarkTWRRByCommitment(
      paramUniverse,
      paramWeight,
      baseorlocalcurrency,
      alternateCurrrency,
      validStartDate,
      validEndtDate,
      weightMethod,
      reportvaluation,
      uniqueCellId,
      advancedParameter
    );
  }
}
